module.exports = __webpack_public_path__ + "img/section.7e52f54a.jpg";